export interface ManageCardTransactionRedirectPayloadModel {
  param1: string;
  param2: string;
  param3: string;
  version: string;

  ipay88OpsgManageCardUrl: string;
}
